export default __webpack_public_path__ + "static/hootsuite-white-14b46a825a814355e1cebe5c86b8e0a0.svg";